import React, { ReactNode } from "react";
import Config from "../../../../Config";
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

const CustomMsalProvider = ({children}) => {
    const msalConfig = Config.getMsalConfig();
    /**
     * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
     * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
     */
    const msalInstance = new PublicClientApplication(msalConfig);

    React.useEffect(() => {
        // Default to using the first account if no account is active on page load
        if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
            // Account selection logic is app dependent. Adjust as needed for different use cases.
            msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }

        // Optional - This will update account state if a user signs in from another tab or window
        msalInstance.enableAccountStorageEvents();

        // Listen for sign-in event and set active account
        msalInstance.addEventCallback((event: any) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                const account = event.payload.account;
                const login = localStorage.getItem("microsoft_login");
                if(login === "1"){
                    localStorage.removeItem("microsoft_login");
                    msalInstance.setActiveAccount(account);
                }
            }
        });
    }, [msalConfig.auth.clientId])
    
    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    )
};

interface Props {
    children: ReactNode;
    clientId: string;
};
const CustomMsalProviderMemo = React.memo(function CustomMsalProviderMemo({children, clientId}: Props){
    return (
        <CustomMsalProvider>
            {children}
        </CustomMsalProvider>
    )
}, (prevProps, nextProps) => {
    if(prevProps.clientId !== nextProps.clientId){
        return false;
    }
    return true;
});

export default CustomMsalProviderMemo;